import dayjs from "dayjs"

export const clearFilterData = {
  SalDte: dayjs().startOf('month'),
  DrvId: null,
}

export const initFilterData = {
  ...clearFilterData
}

export const PAYROLL_STS = {
  0: { label: "ยังไม่สร้าง", color: "default" },
  1: { label: "ร่าง", color: "warning" },
  2: { label: "ยืนยันแล้ว", color: "info" },
  3: { label: "จ่ายแล้ว", color: "success" },
}
